import {getTelegramInitDataUnsafe, getTelegramUserId} from "../services/telegramWebApp";

// parseLaunchParams возвращает параметры запуска Telegram WebApp.
export function parseLaunchParams() {
    const initDataUnsafe = getTelegramInitDataUnsafe();
    const userId = getTelegramUserId();
    const result = {};
    result.tg_user_id = userId;
    result.tg_start_param = initDataUnsafe?.start_param || "";
    return result;
}
